import { AttachmentInvoiceTypes } from "@/shared/types";

export interface OrderHistoryAttachmentsFolder {
  name: string;
  type: AttachmentInvoiceTypes[];
}
export const ORDER_HISTORY_ATTACHMENTS_FOLDERS: OrderHistoryAttachmentsFolder[] =
  [
    {
      name: "order/confirm",
      type: [
        "ORDER_CONFIRMATION_INVOICE",
        "ORDER_SHEET",
        "ORDER_SHEET_ORDERED_PRODUCT",
        "ORDER_SHEET_SET_ZIP_ORDERED_PRODUCT",
        "ORDER_SHEET_UNO_FORM",
        "ORDER_SHEET_SET_UNO_FORM_ORDERED_PRODUCT",
        "ORDER_SHEET_FALLBACK",
        "ORDER_SHEET_SET_ZIP",
        "ORDER_SHEET_SET_ZIP_UNO_FORM",
        "ORDER_SHEET_SET_UNO_FORM",
        "ORDER_SHEET_SET_ATTACHMENT_ZIP",
      ],
    },
    {
      name: "proforma",
      type: ["PROFORMA_INVOICE", "PROFORMA_INVOICE_ATTACHMENT"],
    },
    {
      name: "shipping/customs",
      type: ["TRANSPORTATION", "TRANSPORTATION_PAYMENT", "CUSTOMS"],
    },
    {
      name: "credit/deposit",
      type: ["CREDIT_INVOICE", "DEPOSIT_INVOICE"],
    },
  ];

export const invoicePaymentForGoodsBankAccount = "1005-804-502502";
export const invoiceFeeBankAccount = "1005-303-542796";
